import { IconProps } from './IconProps';

export const CircularTick = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
      style={props.style}
    >
      <path
        d="M10 0C4.48571 0 0 4.48571 0 10C0 15.5143 4.48571 20 10 20C15.5143 20 20 15.5143 20 10C20 4.48571 15.5143 0 10 0ZM14.0786 8.36429L9.79286 12.65C9.65 12.7857 9.47143 12.8571 9.28571 12.8571C9.1 12.8571 8.92143 12.7857 8.77857 12.65L6.63571 10.5071C6.35714 10.2286 6.35714 9.77143 6.63571 9.49286C6.91429 9.21429 7.37143 9.21429 7.65 9.49286L9.28571 11.1357L13.0643 7.35C13.3429 7.07143 13.8 7.07143 14.0786 7.35C14.3571 7.62857 14.3571 8.08571 14.0786 8.36429Z"
        fill="black"
      />
    </svg>
  );
};

